<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Reguł pracy</span>
        <h3 class="page-title">
          <template v-if="isEdit">Edycja reguły pracy pracowników</template>
          <template v-else>Dodawanie reguły pracy pracowników</template>
        </h3>
      </d-col>
      <d-col
        col
        sm="6"
        class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="secondary"
          @click.prevent="$router.push('/reguly')"
          class="mr-1">
          <i class="material-icons">arrow_back</i>
          Wróć do listy
        </d-button>
        <d-button
          theme="success"
          @click.prevent="validateForm">
          Zapisz zmiany
        </d-button>
      </d-col>
    </d-row>
    <!-- Form -->
    <d-form>
      <d-card class="mb-5">
        <d-tabs card>
          <!-- Dane ogólne -->
          <d-tab title="Dane ogólne" active>
            <h4 class="mb-3 pb-3 border-bottom">
              Dane ogólne
            </h4>
            <validation-observer ref="rule-form" tag="form">
              <div class="form-group">
                <validation-provider
                  name="user_id"
                  v-slot="{ errors }">
                  <label for="data.user_id">
                    Specjalista:
                  </label>
                  <filter-select
                    :disabled="isEdit"
                    v-model="data.user_id"
                    style="width: 100%;"
                    :endpoint-items="'/users/items'"
                    :data-id="data.user_id"
                    :reduce="obj => obj.id"
                    :endpoint-item="'/users/item/'"
                    :placeholder="isEdit ? (user.last_name + ' ' + user.last_name) : 'Wybierz specjalistę...'"
                  />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
              <div class="form-group">
                <validation-provider
                  :rules="'required'"
                  name="date_start"
                  v-slot="{ errors }">
                  <label for="date_start">
                    Zakres urlopu:
                  </label>
                  <date-picker
                    :class="['reservation-style', 'mr-2', (importantDate === true && !data.date_start) ? 'invalid-date' : '']"
                    v-model="range"
                    validate
                    range
                    valueType="format"
                    style="width: 100%"/>
                </validation-provider>
                <div class="invalid-feedback" style="display: block;" v-if="importantDate === true && !data.date_start">
                  {{ errors[0] }}
                </div>
              </div>
              <d-card class="p-3" v-if="data.user_id !== '' && data.date_start !== '' && data.date_end !== ''">
                <div class="form-group">
                  <days-and-hours
                    v-if="schedules"
                    :key="startKey"
                    :user-id="data.user_id"
                    :refresh="refreshTimetable"
                    :load-items="schedules"
                    :external-data="true"
                    v-model="data.institutions"
                    :save="saveDaysAndHours"/>
                </div>
                <div class="spinner-load m-0 mb-4" v-if="spinner_load">
                  <div class="spinner-border spinner-border-sm decision-spinner" role="status"></div>
                </div>
              </d-card>
              <div class="rules-save">
                <d-button
                  theme="success"
                  class="text-nowrap"
                  @click.prevent="validateForm">
                  Zapisz zmiany
                </d-button>
              </div>
            </validation-observer>
            <d-alert
              v-if="!schedules"
              show
              theme="warning">
              Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
            </d-alert>
          </d-tab>
        </d-tabs>
      </d-card>
    </d-form>
  </d-container>
</template>

<script>
import FormUtils from '../../../utils/FormUtils.js';
import FilterSelect from '../../others/FilterSelect';
import daysAndHours from '../../others/DaysAndHours';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
  name: 'work-rules-form',
  components: {
    FilterSelect,
    DatePicker,
    daysAndHours
  },
  computed: {
    userData () {
      return this.$store.getters.getAccount
    },
    allDataLoaded () {
      return this.loaded;
    },
    isEdit () {
      return !!this.$route.params.id;
    },
  },
  data() {
    return {
      data: {
        id: 0,
        user_id: '',
        institutions: '',
        start_rule: '',
        end_rule: '',
      },
      loaded: false,
      importantDate: false,
      saveDaysAndHours: false,
      spinner_load: false,
      start_rule: '',
      end_rule: '',
      user: [],
      startKey: 0,
      schedules: [],
      range: [],
      filters: {
        user_id: ''
      }
    };
  },
  watch: {
    'range': function (data) {
      this.data.start_rule = data[0] ? data[0] : this.data.start_rule;
      this.data.end_rule = data[1] ? data[1] : this.data.end_rule;
      this.startKey += 1;
      if (this.data.user_id !== '') {
        this.loadSchedulesUsersItems();
      }
    },
    'data.user_id': function () {
      if (this.data.date_start !== '' && this.data.date_end !== '') {
        this.loadSchedulesUsersItems();
      }
      if (this.isEdit) {
        this.getUserData()
      }
    },
    'start_rule': function () {
      if (this.start_rule !== '' && this.end_rule !== '') {
        this.range = [this.start_rule, this.end_rule]
      }
    }
  },
  mounted () {
    if (this.isEdit) {
      this.loadSchedulesUsersItems();
    }
  },
  methods: {
    getUser () {
      this.$store.dispatch('userAccountGet')
    },
    refreshTimetable () {
      this.loadSchedulesUsersItems();
    },
    getUserData () {
      this.spinner_load = true;
      this.$http.post('/users/item/' + this.data.user_id).then((response) => {
        this.user = response.data.data;
      }).catch((error) => {
        console.log(error);
      });
    },
    loadSchedulesUsersItems () {
      this.spinner_load = true;
      this.loaded = false;
      if (this.isEdit) {
        this.$http.post('rules/get-rule/' + this.$route.params.id, {
        }).then((response) => {
          this.data.user_id = response.data.user_id;
          this.start_rule = response.data.start_rule;
          this.end_rule = response.data.end_rule;
          this.schedules = response.data.data;
          this.spinner_load = false;
        }).catch((error) => {
          console.log(error);
        });
      } else {
        this.$http.post('rules/create-rule', {
          user_id: this.data.user_id
        }).then((response) => {
          this.start_rule = response.data.start_rule;
          this.end_rule = response.data.end_rule;
          this.schedules = response.data.items;
          this.spinner_load = false;
        }).catch((error) => {
          console.log(error);
        });
      }
    },
    validateForm () {
      FormUtils.validate(this.$refs['rule-form'], this.submitForm);
    },
    submitForm () {
      let formDataToSend = this.prepareFormDataToSend();
      let endpointUrl = '/rules/store ';

      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: 'Zapisano regułe',
        successText: 'Wybrana reguła została zapisana',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Modyfikacje reguły nie powiodły się. Spróbuj ponownie.',
        successAction: () => {
          this.$router.push('/reguly')
        },
        cancelAction: () => {
          this.saveDaysAndHours = true;
          this.importantDate = true;
        }
      });
    },
    prepareFormDataToSend () {
      return {
        rule_id: this.$route.params.id,
        user_id: this.data.user_id,
        start_rule: this.data.start_rule,
        end_rule: this.data.end_rule,
        institutions: this.data.institutions
      };
    }
  }
};
</script>

<style lang="scss">
  .rules-save {
    width: 100%;
    text-align: center;
    margin-top: 2rem;

    button {
      max-width: 40%;
      margin: auto;
      width: 100%;
    }
  }
</style>
